import React from "react";

import Dropdown from "components/Dropdown";

import restoreIcon from "assets/images/icons/restore.svg";

const VersionEntryDropdown = ({ open, close, onRestore }) => {
    return (
        <Dropdown
            style={{ top: "30px" }}
            open={open}
            close={close}
            options={[
                {
                    icon: restoreIcon,
                    label: "Restore this version",
                    onClick: () => {
                        onRestore();
                    },
                },
            ]}
        />
    );
};

export default VersionEntryDropdown;
